import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { ResetKeybindingsItem, UnassignKeybindingsItem, } from './components/items';
import styles from './menu.module.scss';
export const KeyboardKeybindingsTableRowMenu = () => {
    return (_jsx(DropdownButton, { noArrow: true, fixed: true, icon: "dots-v", buttonProps: { variant: 'tertiary' }, dropdownProps: { className: styles.dropdown, fixed: true }, dropdown: _jsxs(ButtonList, { children: [_jsx(UnassignKeybindingsItem, {}), _jsx(ResetKeybindingsItem, {})] }) }));
};
